import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { SuperAdminMemberManagementService } from './super-admin-member-management.service';
import { DumbMemberListItem } from './DTOs/dumb-member-list-item';
import { merge, Observable } from 'rxjs';
import { GetMemberListRequest } from './DTOs/get-member-list-request';
import { MembersDtRetInfo } from './DTOs/members-dt-ret-info';
import { ImpersonationService } from '../core/impersonation-service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-super-admin-member-management',
    templateUrl: './super-admin-member-management.component.html',
    providers: [UIBlockingService, NgbDropdown],
    encapsulation: ViewEncapsulation.None
})

export class SuperAdminMemberManagementComponent {

    constructor(private superAdminMemberManagementService: SuperAdminMemberManagementService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private impersonationService: ImpersonationService
        , private router: Router) {

    }

    members: DumbMemberListItem[] = [];
    totalMembers = 0;
    filteredMembers = 0;
    pageNum = 1;
    itemsPerPage = 10;
    searchText = "";
    statusSearch = { display: "Active", value: 1 };
    sortType = 1;
    keywordSearches: string[] = [];
    filtersChanged = true;
    initialLoad = true;

    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        if (!this.initialLoad)
            this.getMembers();
    }
    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }
    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.members.length;
    }


    ngOnInit() {
        var observablesMerged = merge(this.getMembersObservable());
        this.blockUI.start();
        observablesMerged.subscribe(
            {
                next: (data) => {
                    this.members = data.data;
                    this.totalMembers = data.recordsTotal;
                    this.filteredMembers = data.recordsFiltered;
                    this.initialLoad = false;
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                }
            });
    }


    getMembersObservable(): Observable<MembersDtRetInfo> {
        var req = this.createSearchRequest();
        return this.superAdminMemberManagementService
            .getMembersList(req);
    }

    getMembers() {
        this.blockUI.start();

        this.getMembersObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.members = data.data;
                        this.totalMembers = data.recordsTotal;
                        this.filteredMembers = data.recordsFiltered;
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                    }
                });
    }

    createSearchRequest(): GetMemberListRequest {
        var req = new GetMemberListRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;
        req.StatusFilter = this.statusSearch.value;

        this.filtersChanged = false;

        return req;
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13 )//13 is enter, 32 is space
            return;

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getMembers();
        return;
    }
    triggerMemberPasswordReset(contactId) {
        this.blockUI.start();
        this.superAdminMemberManagementService.SendMemberPasswordReset(contactId)
            .subscribe(
                {
                    next: (data) => {
                        this.notificationService.success("Password reset email sent successfully.");
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                    }
                });
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getMembers();
    }

    changeStatusSearch(toChange: number) {
        if (this.statusSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case 1:
                this.statusSearch = { display: "Active", value: 1 };
                break;
            case 2:
                this.statusSearch = { display: "Deactivated", value: 2 };
                break;
            case 3:
                this.statusSearch = { display: "All", value: 3 };
                break;
            case 4:
                this.statusSearch = { display: "Pending", value: 4 };
                break;
            case 5:
                this.statusSearch = { display: "Denied", value: 5 };
                break;
            default:
                this.statusSearch = { display: "Active", value: 1 };
                break;
        }
        this.getMembers();
    }
    clearSearch() {
        this.searchText = "";
        this.statusSearch = { display: "Active", value: 1 };
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.getMembers();
    }
    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getMembers();
    }
    changeSortType(column: number) {
        switch (column) {
            case 1:
                this.sortType = (this.sortType == 1) ? 2 : 1;
                break;
            case 2:
                this.sortType = (this.sortType == 3) ? 4 : 3;
                break;
            case 3:
                this.sortType = (this.sortType == 5) ? 6 : 5;
                break;
            case 4:
                this.sortType = (this.sortType == 7) ? 8 : 7;
                break;
            default:
                break;
        }
        this.filtersChanged = true;
        this.getMembers();
    }

    impersonate(member: DumbMemberListItem): void {
        this.blockUI.start();
        this.impersonationService.beginImpersonation(member.liaisonId).subscribe({
            next: (status) => {
                this.impersonationService.impersonationStatus.next(status);
                localStorage.setItem('userFirstName', status.userFirstName);
                localStorage.setItem('userLastName', status.userLastName);
                localStorage.setItem('contactId', status.contactId);
                localStorage.setItem('contactType', status.contactType);
                localStorage.setItem('userEmailAddress', status.userEmailAddress);
                localStorage.setItem('impersonating', "true");
                localStorage.setItem('impersonatedContactName', `${status.userFirstName} ${status.userLastName}`);
                localStorage.setItem('membershipLevel', status.membershipLevel);
                var url = '/app/home';
                this.router.navigate([url]).then(() => {
                    this.blockUI.stop();
                });
            }
        });
    }

}
